module.exports = __webpack_public_path__ + "img/xianchangkancha.22f5476a.png";